export default __webpack_public_path__ + "static/media/naa-dedei.bcbec8d4.jpeg";